import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import Box from '@mui/material/Box';
import DataBox from '../../../general/data/DataBox';
import DataRow from '../../../general/data/DataRow';

import CreditCardIcon from '@mui/icons-material/CreditCard';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import { getGroupDataUsage, getGroupSubscription } from '../../../../routes/hacker/users';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import { setSelectedGroupBillingInfo } from '../../../../redux/features/hacker/users/groupsAccess';
import InfoRow from '../../../general/inputs/InfoRow';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
import moment from 'moment';
import YardOutlinedIcon from '@mui/icons-material/YardOutlined';
import TodayIcon from '@mui/icons-material/Today';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import FaceOutlinedIcon from '@mui/icons-material/FaceOutlined';

interface Props { 

}; 

const GroupBillingInfo: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const selectedGroup = useAppSelector(state => state.groupsAccess.selectedGroup); 
    const selectedGroupBillingInfo = useAppSelector(state => state.groupsAccess.selectedGroupBillingInfo); 

    const [startDate, setStartDate] = useState(''); 
    const [endDate, setEndDate] = useState(''); 

    const handleGroupSubscription = async () => { 
        if (!selectedGroup) return;
        const res = await getGroupSubscription(selectedGroup._id) as any;  
        if (res.data?.status === 200) { 
            dispatch(setSelectedGroupBillingInfo(res.data)); 
        }; 
    }; 

    useEffect(() => { 
        if (selectedGroup) { 
            handleGroupSubscription(); 
        }; 
    },[selectedGroup]); 

    const getSubscriptionDates = () => { 
        if (selectedGroupBillingInfo?.subscription) { 
            if (selectedGroupBillingInfo.subscription.status === 'trialing') { 
                setStartDate(moment.unix(selectedGroupBillingInfo.subscription.trial_start).utc(true).format('LL')); 
                setEndDate(moment.unix(selectedGroupBillingInfo.subscription.trial_end).utc(true).format('LL')); 
            } else { 
                setStartDate(moment.unix(selectedGroupBillingInfo.subscription.items.data[0]?.current_period_start).utc(true).format('LL')); 
                setEndDate(moment.unix(selectedGroupBillingInfo.subscription.items.data[0]?.current_period_end).utc(true).format('LL')); 
            }
        } else if (selectedGroup) {
            // --- START OF FIX ---
            setStartDate(moment(selectedGroup.createdAt).utc(true).format('LL'));
            if (selectedGroup.trialEndDate) {
                setEndDate(moment(selectedGroup.trialEndDate).utc(true).format('LL'));
            } else {
                setEndDate(moment(selectedGroup.createdAt).utc(true).add(14, "days").format('LL'));
            }
            // --- END OF FIX ---
        }
    }; 

    useEffect(() => { 
        getSubscriptionDates(); 
    },[selectedGroupBillingInfo, selectedGroup]); 

    return (
        <>
            {(selectedGroupBillingInfo?.currentPlan === 'subscription') ? 
            <DataBox title='Billing Info'>
                <InfoRow icon={<YardOutlinedIcon sx={{ color: colors?.main }} />} title='Stripe Status' description={getCapitalizedString(selectedGroupBillingInfo?.subscription?.status)} descriptionStyle={{ color: 'rgb(102, 101, 99)', fontWeight: 'bold' }} />
                <InfoRow icon={<TodayIcon sx={{ color: colors?.main }} />} title='Start Date' description={startDate} descriptionStyle={{ color: 'rgb(10, 70, 10)' }} />
                <InfoRow icon={<InsertInvitationIcon sx={{ color: colors?.main }} />} title='Ends On' description={endDate} descriptionStyle={{ color: 'rgb(68, 33, 12)' }} />
                <InfoRow icon={<CreditCardIcon sx={{ color: colors?.main }} />} title='Card' description={`**** ${selectedGroupBillingInfo?.paymentMethod?.card?.last4}`} />
                <InfoRow icon={<AccountBalanceIcon sx={{ color: colors?.main }} />} title='Type' description={getCapitalizedString(selectedGroupBillingInfo?.paymentMethod?.card?.brand)} />
                <InfoRow icon={<AccountBoxOutlinedIcon sx={{ color: colors?.main }} />} title='Card Holder' description={selectedGroupBillingInfo?.customer?.name?.toUpperCase()} />
                <InfoRow icon={<FaceOutlinedIcon sx={{ color: colors?.main }} />} title='Customer Id' description={selectedGroupBillingInfo?.customer?.id} />
                <InfoRow icon={<MailOutlineIcon sx={{ color: colors?.main }} />} title='Email' description={selectedGroupBillingInfo?.paymentMethod?.billing_details?.email} />
                <InfoRow icon={<ReceiptOutlinedIcon sx={{ color: colors?.main }} />} title='Next Invoice' description={`$${selectedGroupBillingInfo?.nextInvoicePreview?.amount_remaining / 100}`} />
            </DataBox> : 
            <DataBox title='Billing Info'>
                <InfoRow icon={<YardOutlinedIcon sx={{ color: colors?.main }} />} title='Current Plan' description={getCapitalizedString(selectedGroupBillingInfo?.currentPlan)} descriptionStyle={{ color: 'rgb(102, 101, 99)' }} />
                <InfoRow icon={<TodayIcon sx={{ color: colors?.main }} />} title='Start Date' description={startDate} descriptionStyle={{ color: 'rgb(102, 101, 99)' }} />
                <InfoRow icon={<InsertInvitationIcon sx={{ color: colors?.main }} />} title='Ends On' description={endDate} descriptionStyle={{ color: 'rgb(102, 101, 99)' }} />
            </DataBox>}
        </>
  );

};

export default GroupBillingInfo;